import * as PropTypes from 'prop-types';
import Spin from 'antd/lib/spin';
import { useFela } from 'react-fela';

const rule = () => ({
    display: 'block',
    margin: 'auto',
});

export default Component => {
    const Loadable = ({ showLoader, loaderText, ...props }) => {
        const { css } = useFela();

        return showLoader ? <Spin className={css(rule)} tip={loaderText || ''} /> : <Component {...props} />;
    };

    Loadable.propTypes = {
        showLoader: PropTypes.bool,
        loaderText: PropTypes.string,
    };

    Loadable.defaultProps = {
        showLoader: false,
        loaderText: 'Loading...',
    };

    return Loadable;
};
